import React, { useEffect, useRef, useState } from "react";
import G6 from '@antv/g6';
import insertCss from 'insert-css';
import dataInfo from '../../data';

insertCss(`
    .g6-tooltip {
      border-radius: 6px;
      font-size: 12px;
      color: #fff;
      background-color: #000;
      padding: 2px 8px;
      text-align: center;
    }
`);


function findMinNumber(arr) {
    return Math.min(...arr);
}

function lastNodes(graph, type) {
    // 获取所有节点
    const nodes = graph.getNodes();
    // 找出最后一层的节点id
    let lastLayerNodes = [];
    let num = [];
    nodes.forEach(node => {
    const model = node.getModel();
    if (!num.includes(model._order)) {
        num.push(model.y)
    }
    });
    // 寻找最小值
    let minNumber = findMinNumber(num);
    lastLayerNodes = nodes.filter(node => {
        let model = node.getModel();
        if (model.y == minNumber)
        {   
            return node
        }
    });
    return type == 'id' ? lastLayerNodes.map(item => item._cfg.id) : lastLayerNodes
}

const Dagre = ({ nodeClick, location = {} }) =>
{

     const [graphDom, setGraphDom] = useState(null);
    const {name} = location.state || {};
    
    const containerRef = useRef(null);
    const data = name ? require(`../data/${name}/职业树`).default : {};

    const setNum = (cfg, props, type) =>
    {
        let lastObj = {
            x: -50,
            y: -50,
            width: 100,
            height: 100,
            stroke: '#E2211C',
            fill: '#F5F7FA',
            radius: 50,
            color: "#E2211C",
        }
        let firstSelectedObj = {
            x: -75,
            y: -25,
            width: 150,
            height: 60,
            stroke: '#4FAF7C',
            fill: '#4FAF7C',
            radius: 4,
            color: "#000",
        }
        let firstObj = {
            x: -75,
            y: -25,
            width: 150,
            height: 60,
            stroke: '#4FAF7C',
            fill: '#4FAF7C',
            radius: 4,
            color: "#fff",
        }
        let defaultObj = {
            x: -75,
            y: -25,
            width: 150,
            height: 60,
            stroke: '#CFD4DF',
            fill: '#fff',
            radius: 4,
            color: "#333",
        }
        // if (cfg.id == data.nodes[data.nodes.length - 1].id) {
        //     console.log(cfg,group, '================last');
            
        //     return lastObj[props]
        // } 
        if (cfg.id == data.nodes[0].id) {
            if (type && type == 'selected')
            {
                return firstSelectedObj[props]
            } else {
                return firstObj[props]
            }
        } else {
            return defaultObj[props]
        }
    }

    const createChart = () =>
    {
        G6.registerNode(
            'sql',
            {
              drawShape(cfg, group) {
                const rect = group.addShape('rect', {
                  attrs: {
                    x: setNum(cfg, 'x'),
                    y: setNum(cfg, 'y'),
                    width: setNum(cfg, 'width'),
                    height: setNum(cfg, 'height'),
                    radius: setNum(cfg, 'radius'),
                    stroke: setNum(cfg, 'stroke'),
                    fill: setNum(cfg, 'fill'),
                    lineWidth: 3,
                  },
                  name: 'rect-shape',
                });
                
                // group.addShape('line', {
                //     attrs: {
                //         x1: cfg.id == data.nodes[0].id ? -82 : -40,
                //         y1: cfg.id == data.nodes[0].id ? 20 : 24,
                //         x2: cfg.id == data.nodes[0].id ? 82 : 40,
                //         y2: cfg.id == data.nodes[0].id ? 20 : 24,
                //         stroke: '#29625A',
                //         lineWidth: 2
                //     },
                //     name: 'bottom-border-line'
                // });
                // group.addShape('line', {
                //     attrs: {
                //         x1: cfg.id == data.nodes[0].id ? -82 : -40,
                //         y1: cfg.id == data.nodes[0].id ? 29 :34,
                //         x2: cfg.id == data.nodes[0].id ? 82 : 40,
                //         y2: cfg.id == data.nodes[0].id ? 29 :34,
                //         stroke: '#29625A',
                //         lineWidth: 2
                //     },
                //     name: 'top-border-line'
                // });
                if (cfg.name) {
                  group.addShape('text', {
                    attrs: {
                      text: cfg.name,
                      x: 0,
                      y: 0,
                      fill: setNum(cfg, 'color'),
                      fontSize: 14,
                      textAlign: 'center',
                      textBaseline: 'middle',
                      fontWeight: 'bold',
                    },
                    name: 'text-shape',
                  });
                }
                return rect;
              },
              // 关键：处理状态变化
                setState(name, value, item) {
                    const group = item.getContainer();
                    // 获取修改文字的节点
                    const textShape = group.find(ele => ele.get('name') === 'text-shape');
                    // 获取修改背景颜色的节点
                    const bgShape = group.find(ele => ele.get('name') == 'rect-shape');
                    let lastLayerNodes = lastNodes(graph, 'id');
                    
                    if (name === 'selected') {
                        if (value) {
                            textShape.attr('fill', setNum(item._cfg.model, 'color', 'selected')); // 恢复默认
                            bgShape.attr('fill', '#EDFFF5');
                            bgShape.attr('stroke', '#4FAF7C');
                        } else if (lastLayerNodes.includes(item._cfg.id)) {
                            textShape.attr('fill', "#E2211C"); 
                            bgShape.attr('fill', '#F5F7FA');
                            bgShape.attr('stroke', '#E2211C');
                        } else {
                            textShape.attr('fill', setNum(item._cfg.model, 'color')); // 恢复默认
                            bgShape.attr('fill', setNum(item._cfg.model, 'fill'));
                            bgShape.attr('stroke', setNum(item._cfg.model, 'stroke'));
                        }
                    }
                }
            },
            'single-node',
        );
        // console.log(containerRef && containerRef.current && containerRef.current?.offsetHeight, '=========containerRef && containerRef.current && containerRef.current?.offsetHeight');
        // if (!(containerRef && containerRef.current && containerRef.current?.clientHeight)) {
        //     console.log(containerRef);
            
        //     return false
        // }
        const width = containerRef.current.offsetWidth || 1000;
        const height = containerRef.current.clientHeight || 800;
        const graph = new G6.Graph({
            container: containerRef.current,
            width,
            height,
            layout: {
                type: 'dagre',
                rankdir: 'BT',
                nodesepFunc: (d) => {
                    // if (d.id === '3') {
                    //     return 500;
                    // }
                    return 50;
                },
                // ranksep: 20,
                controlPoints: true,
            },
            defaultNode: {
                type: 'sql',
            },
            defaultEdge: {
                type: 'polyline',
                    style: {
                    // radius: 20,
                    offset: 45,
                    // offset: 0,
                    endArrow: true,
                    lineWidth: 2,
                    stroke: '#CFD4DF',
                },
            },
            nodeStateStyles: {
                selected: {
                    labelCfg: {
                        style: {
                            fill: '#333',  // 默认字体颜色
                            fontSize: 12
                        }
                    },
                    stroke: '#4FAF7C',
                    fill: '#EDFFF5',
                },
            },
            modes: {
                default: [
                'drag-canvas',
                'zoom-canvas',
                'click-select',
                // {
                //     type: 'tooltip',
                //     formatText(model) {
                //         const cfg = model.conf;
                //         const text = [];
                //         cfg.forEach((row) => {
                //             text.push(row.label + ':' + row.value + '<br>');
                //         });
                //         return text.join('\n');
                //     },
                //     offset: 30,
                // },
                ],
            },
            fitView: true,
        });
        graph.on("node:click", evt => {
            // 一些操作
            if (nodeClick) 
            {
                nodeClick(evt)
            }
            // 清除所有选中状态
            graph.getNodes().forEach(node => {
                graph.clearItemStates(node, 'selected');
            });
            // 设置当前节点为选中状态
            graph.setItemState(evt.item, 'selected', true);
        });
        setGraphDom(graph)
        graph.data(data);
        graph.render();
        graph.on('afterlayout', () => {
            // 获取所有节点
            const nodes = graph.getNodes();
            // 找出最后一层的节点
            let lastLayerNodes = [];
            let num = [];
            nodes.forEach(node => {
              const model = node.getModel();
              if (!num.includes(model._order)) {
                num.push(model.y)
              }
            });

            let minNumber = findMinNumber(num);

            lastLayerNodes = nodes.filter(node => {
                let model = node.getModel();
                if (model.y == minNumber)
                {
                    return node
                }
            });
            
            // 修改最后一层节点的颜色
            lastLayerNodes.forEach(node => {
                node.update({
                    style: {
                        x: -50,
                        y: -50,
                        width: 100,
                        height: 100,
                        stroke: '#E2211C',
                        fill: '#F5F7FA',
                        radius: 50,
                    }
                });
                console.log(node);
              
                let textShape = node.getContainer().find(ele => ele.get('type') === 'text');
                textShape.attr('fill', '#E2211C');
            });
          });
    }

    useEffect(() =>
    {
        if (containerRef && containerRef.current){
            createChart()
        }
    }, []);
    useEffect(() =>
    {
        if (graphDom) {
            
            graphDom.data(data);
            graphDom.render();
        }
    }, [containerRef]);

    return <div id="dagre_chart" ref={containerRef} style={{ height: "100%" }}></div>
}

export default Dagre;